<template>
  <v-app id="onBcms">

    <!-- :actions="bcms.action_items" -->
    <defNavBar title="Ares - Guest message" :home="true" :attms="0" :notts="0" @actionClick="actionClick"/>

    <v-main> 
      
      <v-container fluid>
        <!-- <v-snackbar v-model="snackbar" top color="success" :timeout="2000">{{ snackbarMessage }}</v-snackbar> -->
        <v-row>  
          
          <v-col cols="12" lg="6" class="px-1"> <!-- Links -->
            <v-container>
              <v-row>
                <v-col cols="12" class="px-1">
                  <v-card>
                  <v-form ref="bcmsCard1">
                  <v-card-title>
                    {{ bcms.hust_oms }} {{ bcms.bcms_code }}
                    <v-chip :color=bcms.hust_kleur class="mx-4"> {{bcms.hust_code}} </v-chip>
                    <span class="mx-3 orange--text"> {{bcms.bcms_type}} </span>
                  </v-card-title>

                  <v-row no-gutters>
                    <v-col cols="3" class="mx-1">
                      <v-text-field v-model="bcms.bcms_dt" readonly label="Booking date" dense></v-text-field>
                    </v-col>
                    <v-col cols="2" class="mx-1">
                      <v-text-field v-model="bcms.gebr_code_nw" readonly label="Booked by" dense></v-text-field>
                    </v-col>
                    <v-col cols="3" class="mx-1">
                      <v-text-field @click="$refs.bcmsInpt.open(bcms.bcms_encrid);" v-model="bcms.inpt_naam" readonly label="Sales partner / website" dense></v-text-field>
                    </v-col>
                    <v-col cols="3" class="mx-1" v-if="bcms.bcms_ota_code > ''">
                      <v-text-field v-model="bcms.bcms_ota_code" readonly label="Sales partner booking ID" dense></v-text-field>
                    </v-col>

                  </v-row>
                  <v-row v-if="bcms.hust_code == 'B-AZV'" no-gutters>
                    <v-col cols="3" class="mx-1">
                      <v-text-field v-model="bcms.bcms_ann_dt" readonly label="Cancellation date" dense></v-text-field>
                    </v-col>
                    <v-col cols="2" class="mx-1">
                      <v-text-field v-model="bcms.bcms_ann_schuld" readonly label="Initiated" dense></v-text-field>
                    </v-col>
                    <v-col cols="2" class="mx-1">
                      <v-text-field v-model="bcms.gebr_code_ann" readonly label="Cancelled by" dense></v-text-field>
                    </v-col>
                    
                  </v-row>
                  <v-row no-gutters>  
                    <v-col cols="5" class="mx-1">
                      <v-text-field @click="$refs.bcmsArrDep.open(bcms.bcms_encrid);" v-model="bcms.bcms_van_samengesteld" readonly label="Arrival" dense></v-text-field>
                    </v-col>
                    <v-col cols="5" class="mx-1">
                      <v-text-field @click="$refs.bcmsArrDep.open(bcms.bcms_encrid);" v-model="bcms.bcms_tm_samengesteld" readonly label="Departure" dense></v-text-field>
                    </v-col>
                    <v-col cols="1" class="mx-1">
                      <v-text-field v-model="bcms.bcms_aant_nacht" readonly label="Nights" dense></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row no-gutters>
                    <v-col cols="1" class="mx-1">
                      <v-text-field @click="$refs.bcmsTravelParty.open(bcms.bcms_encrid);" v-model="bcms.bcms_aant_volw" readonly label="Adults" dense></v-text-field>
                    </v-col>
                    <v-col cols="1" class="mx-1">
                      <v-text-field @click="$refs.bcmsTravelParty.open(bcms.bcms_encrid);" v-model="bcms.bcms_aant_kind" readonly label="Children" dense></v-text-field>
                    </v-col>
                    <v-col cols="1" class="mx-1">
                      <v-text-field @click="$refs.bcmsTravelParty.open(bcms.bcms_encrid);" v-model="bcms.bcms_aant_baby" readonly label="Babies" dense></v-text-field>
                    </v-col>
                    <v-col cols="1" class="mx-1">
                      <v-text-field @click="$refs.bcmsTravelParty.open(bcms.bcms_encrid);" v-model="bcms.bcms_aant_hd" readonly label="Pets" dense></v-text-field>
                    </v-col>
                    <v-col cols="1" class="mx-1">
                      <v-text-field @click="$refs.bcmsTravelParty.open(bcms.bcms_encrid);" v-model="bcms.bcms_aant_hogs" readonly label="Travel Party" dense></v-text-field>
                    </v-col>
                    <v-col cols="2" class="mx-1">
                      <v-text-field @click="$refs.bcmsHandling.open(bcms.bcms_encrid);" v-model="bcms.bcms_handling_verk" readonly label="VFY handles Guest" dense></v-text-field>
                    </v-col>
                    <v-col cols="2" class="mx-1">
                      <v-text-field @click="$refs.bcmsHandling.open(bcms.bcms_encrid);" v-model="bcms.bcms_handling_ink" readonly label="VFY handles Hosts" dense></v-text-field>
                    </v-col>
                    <v-col cols="3" class="mx-1" v-if="bcms.bcms_optie_verval_dt > ''">
                      <v-text-field  v-model="bcms.bcms_optie_verval_dt" readonly label="Expire date / time" dense></v-text-field>
                    </v-col>
                  </v-row>
                  
                    
                  </v-form>
                  </v-card>
                </v-col>
              </v-row>


            </v-container>
          </v-col>

        </v-row>
      </v-container>
      <m_attm ref="m_attm"></m_attm>
      <nott ref="nott"></nott>
      <!-- <bcmsGuestEmails ref="bcmsGuestEmails"></bcmsGuestEmails>
      <bcmsHostEmails ref="bcmsHostEmails"></bcmsHostEmails>
      <bcmsTravelParty ref="bcmsTravelParty"></bcmsTravelParty>
      <bcmsArrDep ref="bcmsArrDep"></bcmsArrDep>
      <mvHklrPayment ref="mvHklrPayment"></mvHklrPayment>
      <mvHctrPayment ref="mvHctrPayment"></mvHctrPayment>
      <mvHobo ref="mvHobo"></mvHobo>
      <bcmsExpExt ref="bcmsExpExt"></bcmsExpExt>
      <vstdBknDny ref="vstdBknDny"></vstdBknDny>
      <astdBknDny ref="astdBknDny"></astdBknDny>
      <bcmsInpt ref="bcmsInpt"></bcmsInpt>
      <bcmsHandling ref="bcmsHandling"></bcmsHandling>
      <bcmsSendDocuGuest ref="bcmsSendDocuGuest"></bcmsSendDocuGuest>
      <bcmsSendDocuHost ref="bcmsSendDocuHost"></bcmsSendDocuHost> -->
    </v-main>
  </v-app>
</template>




<script>
import { bus } from "../../../../main";
import m_attm from "@/components/m_attm.vue";
import nott from "@/components/nott.vue";
import defNavBar from '@/components/ui/navbars/navbar.vue';
 export default {
  components: {
    nott,
    m_attm,
    defNavBar
  },
  props: ['bcms_encrid'],
  data() {
    return {
      stat_codeKeuzes: [],
      bcms: {
        bcms_naam: '',
        stat_code: '',
        action_items: []  /* moet pre defined ivm length check */
      },
      snackbar: false,
      snackbarMessage: ''
    }
    
  },
  mounted() {
    this.getBcms();
  },
  created() {
    bus.$on("closeDialog", (data) => {
      console.log(data);
      if(data==='reload' || data==='attm_m_attm'){
        this.getBcms();
      }
    });  
    bus.$on("addNote", (data) => {
       console.log(data);
       this.bcms.nott_aant += data;
    });            
  },  
  methods: {
    getBcms(){
      this.$axios
      .post("ares/json/ares/task/guestMessages/bcms/getBcms.p", {
        header: {
          token: this.$session.get("ARES"),
          clientSessionId: this.$session.id(),
          request: "getBcms"
        },
        getBcms: {
          bcms_encrid: this.bcms_encrid
       }
      })
      .then(res => {
        if (res.data.error) {
          console.log(res.data.error);
        } else {
           this.bcms = res.data.getBcms;
           document.title = 'Booking ' + res.data.getBcms.bcms_code;
        }
      });
    },
    actionClick(action) {
      switch(action) {
        // case "Cancel" : this.$refs.bcmsCancel.open(this.bcms_encrid); break;
        // case "bcmsGuestEmails" : this.$refs.bcmsGuestEmails.open(this.bcms_encrid); break;
        // case "bcmsHostEmails" : this.$refs.bcmsHostEmails.open(this.bcms_encrid); break;
        // case "bcmsExpExt" : this.$refs.bcmsExpExt.open(this.bcms_encrid); break;
        // case "vstdBknDny" : this.$refs.vstdBknDny.open(this.bcms_encrid); break;
        // case "astdBknDny" : this.$refs.astdBknDny.open(this.bcms_encrid); break;
        // case "mvHobo" : this.$refs.mvHobo.open(this.bcms_encrid); break;
        // case "bcmsSendDocuGuest" : this.$refs.bcmsSendDocuGuest.open(this.bcms_encrid); break;
        // case "bcmsSendDocuHost" : this.$refs.bcmsSendDocuHost.open(this.bcms_encrid); break;
        case "nott" : this.$refs.nott.open("bcms", this.bcms_encrid, "all"); break;
        case "m_attm" : this.$refs.m_attm.open('bcms', this.bcms.bcms_code, '', 'bcms', this.bcms_encrid, 0); break;
      }
    }
  }
};

</script> 
